/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["article[_ngcontent-%COMP%]{background-color:#fff;padding:20px;font-size:80%}h3[_ngcontent-%COMP%]{font-weight:700;font-size:200%;padding-top:10px;padding-bottom:10px}h4[_ngcontent-%COMP%]{font-weight:700;font-size:130%;padding-top:10px;padding-bottom:10px}ul[_ngcontent-%COMP%]{list-style-type:square;list-style-position:inside}"];
export { styles as styles };
